<template>
	<component :is="level" class="heading"> <slot /> </component>
</template>

<script>
/**
 * Headings are used as the titles of each major section of a page in the
 * interface. For example, templates generally use headings as their title.
 * Heading element provides an option to change the level of the heading.
 */
export default {
	name: "EbHeading",
	status: "prototype",
	release: "1.0.0",
	props: {
		/**
		 * The heading level used for the heading.
		 * @values h1, h2, h3, h4, h5, h6
		 */
		level: {
			type: String,
			default: "h1",
			validator: value => {
				return value.match(/(h1|h2|h3|h4|h5|h6)/)
			},
		},
	},
}
</script>

<style lang="scss">
.eb-heading {
	@include stack-space($eb-space-l);
	color: $black;
}
h1,
h2 {
	text-transform: uppercase;
	font-weight: $eb-font-weight-semibold;
}
h3 {
	font-weight: $eb-font-weight-semibold;
}
h4,
h5,
h6 {
	font-weight: $eb-font-weight-bold;
}

/*----------------------------------------------------
  #HEADING
  --------------------------------------------------*/

h1,
h2,
h3,
h4,
h5,
h6 {
	word-wrap: break-word;
	/*line-height: 1.2;*/
}

h1 {
	@include fluid-type(font-size, $Width-min, $Width-max, $fontSize-min * $scale6, $fontSize-max * $scale6);
}

h2 {
	@include fluid-type(font-size, $Width-min, $Width-max, $fontSize-min * $scale5, $fontSize-max * $scale5);
}

h3 {
	@include fluid-type(font-size, $Width-min, $Width-max, $fontSize-min * $scale4, $fontSize-max * $scale4);
}

h4 {
	@include fluid-type(font-size, $Width-min, $Width-max, $fontSize-min * $scale3, $fontSize-max * $scale3);
}

h5 {
	@include fluid-type(font-size, $Width-min, $Width-max, $fontSize-min * $scale2, $fontSize-max * $scale2);
}

h6 {
	@include fluid-type(font-size, $Width-min, $Width-max, $fontSize-min * $scale1, $fontSize-max * $scale1);
}

/*----------------------------------------------------
  #HEADING VERTICAL BALANCE
  --------------------------------------------------*/

/* Of course, you can use your own values*/
/*
$h1:    3.5rem;
$h2:    3em;
$h3:    2.5rem;
$h4:    2rem;
$h5:    1.5rem;
$h6:    1.35rem;
*/

$h1: 2rem;
$h2: 1.75rem;
$h3: 1.5rem;
$h4: 1.25rem;
$h5: 1.15rem;
$h6: 1rem;

h1 {
	margin-top: -webkit-calc((#{$baseline} - #{$h1}) + #{$baseline});
	margin-top: calc((#{$baseline} - #{$h1}) + #{$baseline});
}

h2 {
	margin-top: -webkit-calc((#{$baseline} - #{$h2}) + #{$baseline}* 2);
	margin-top: calc((#{$baseline} - #{$h2}) + #{$baseline}* 2);
}

h3 {
	margin-top: -webkit-calc((#{$baseline} - #{$h3}) + #{$baseline}* 2);
	margin-top: calc((#{$baseline} - #{$h3}) + #{$baseline}* 2);
}

h4 {
	margin-top: -webkit-calc((#{$baseline} - #{$h4}) + #{$baseline}* 2);
	margin-top: calc((#{$baseline} - #{$h4}) + #{$baseline}* 2);
}

h5 {
	margin-top: -webkit-calc((#{$baseline} - #{$h5}) + #{$baseline}* 2);
	margin-top: calc((#{$baseline} - #{$h5}) + #{$baseline}* 2);
}

h6 {
	margin-top: -webkit-calc((#{$baseline} - #{$h6}) + #{$baseline}* 2);
	margin-top: calc((#{$baseline} - #{$h6}) + #{$baseline}* 2);
}
</style>
